module.exports = __webpack_public_path__ + "static/media/b-2.4cff7c82.jpg";